import { useTranslator } from '@bluebeam/react-i18n';
import { useAuth } from 'auth';
import LoadingAnimation from 'components/LoadingAnimation';
import Navigation from 'components/Navigation';
import { Set } from 'immutable';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { CreateRFI } from 'records/interactions/CreateRFI';
import { NewRFI } from 'records/NewRFI';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import RFIList from './RFIList';
import RFISubheader from './RFISubheader';

interface Props extends WithAppStoreProps, RouteComponentProps {}

const RFIPage = (props: Props) => {
  const { userId } = useAuth();
  const { translate } = useTranslator(['rfiPage']);
  const [loaded, setLoaded] = useState<boolean>(false);
  const {
    appState: { users, selectedProject },
    actions,
  } = props;

  useEffect(() => {
    const loadRFIs = async (): Promise<void> => {
      await actions.getRFIs();
      await actions.queryRFIsFromTable();

      setLoaded(true);
    };

    !loaded && loadRFIs();
    return () => {
      setLoaded(false);
      actions.setSelectedRFIs(Set<string>());
      actions.clearInteractions();
    };
  }, []);

  const handleCreateRFI = (): void => {
    const currentUser = users.find((u) => userId === u.id);
    const now = new Date();

    const interaction = new CreateRFI({
      rfi: new NewRFI({
        projectid: selectedProject,
        duedate: Math.floor(now.setDate(now.getDate() + 3) / 1000),
        submittingname: `${currentUser?.profile.firstname} ${currentUser?.profile.lastname}`,
        submittingemail: currentUser?.email,
        submittingcompany: currentUser?.profile.company || ' ',
      }),
    });

    actions.createInteraction(interaction);
  };

  return (
    <>
      <Navigation>
        {loaded ? (
          <div className="m4">
            <RFISubheader onCreateRFI={handleCreateRFI} />
            <RFIList onCreateRFI={handleCreateRFI} />
          </div>
        ) : (
          <LoadingAnimation pageName={translate('rfiPage:loadingRfis')} />
        )}
      </Navigation>
    </>
  );
};

export default withAppStore<Props>(RFIPage);
